/**
 * Clancy Tuning "Precision Forge" design tokens — single source of truth.
 *
 * Mirrors C:\Users\hodgi\Documents\ClancyTuning\src\styles\theme.ts so the web
 * brand site, the desktop app, and the analyzer share one palette.
 */

export const colors = {
  background: '#0A0A0F',
  surface: '#14141F',
  elevated: '#1E1E2E',
  border: '#2A2A3A',

  forgeStart: '#FF6B2C',
  forgeEnd: '#FF8F4C',

  safetyGreen: '#00E676',
  warningAmber: '#FFB300',
  dangerRed: '#FF1744',
  aiPurple: '#BB86FC',

  textPrimary: '#F0F0F5',
  // Tuned to clear WCAG AA on every surface in the palette.
  textSecondary: '#9999B0',
  textMuted: '#8E8EA0',
} as const;

export const radii = {
  none: '0',
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  '2xl': '24px',
  full: '9999px',
} as const;

export const shadows = {
  card: '0 4px 16px rgba(0, 0, 0, 0.45)',
  elevated: '0 8px 32px rgba(0, 0, 0, 0.55)',
  forgeGlow: '0 0 24px rgba(255, 107, 44, 0.35)',
  forgeGlowSoft: '0 0 48px rgba(255, 107, 44, 0.18)',
} as const;

export const fontFamilies = {
  sans: 'Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Helvetica, Arial, sans-serif',
  mono: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
} as const;

/** Motion tokens — durations in ms. Honor prefers-reduced-motion at the call site. */
export const motion = {
  duration: {
    instant: 100,
    quick: 160,
    standard: 220,
    emphasized: 320,
  },
  easing: {
    standard: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
    enter: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
    exit: 'cubic-bezier(0.4, 0.0, 1, 1)',
  },
} as const;

export const gradients = {
  forge: `linear-gradient(135deg, ${colors.forgeStart} 0%, ${colors.forgeEnd} 100%)`,
  forgeRadial: `radial-gradient(circle at 30% 20%, rgba(255, 107, 44, 0.22) 0%, transparent 55%)`,
  aiRadial: `radial-gradient(circle at 80% 10%, rgba(187, 134, 252, 0.16) 0%, transparent 50%)`,
} as const;

export type Colors = typeof colors;
